'use client'

import { Plus } from "lucide-react"
import Link from "next/link"
import { useLocale } from 'next-intl'
import { useLocalizedField } from '@/hooks/useLocalizedField'

export default function MedicalStay({ item }: { item: any }) {
  const locale = useLocale()
  const { getLocalizedField } = useLocalizedField()
  
  const title = getLocalizedField(item, 'title', item.title || 'Unknown')
  
  return (
    <div
      className="relative h-64 w-96 rounded-2xl overflow-hidden  group bg-cover bg-center"
      style={{
        backgroundImage: `url(${item.cover || "/placeholder.svg"})`,
      }}
      dir={locale === 'ar' ? 'rtl' : 'ltr'}
    >
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent" />

      {/* Text overlay at bottom */}
      <div className="absolute bottom-0 left-0 right-0 p-4 z-10">
        <h3 className="font-semibold text-lg text-white">
          {title}
        </h3>
      </div>

      {/* Plus button in bottom right/left based on locale */}
<Link
  href={`/${locale}/medical-stays/${item.slug}`}
  className={`absolute bottom-4 z-20 bg-white rounded-full p-2 shadow-lg ${locale === 'ar' ? 'left-4' : 'right-4'}`}
>
  <Plus className="w-6 h-6 text-gray-800" />
</Link>
    </div>
  )
}
